export default __webpack_public_path__ + "assets/favicon.25521501.png";